import { createSlice } from '@reduxjs/toolkit'

export const dateFormatSlice = createSlice({
  name: 'dateFormat',
  initialState: {
    value: 'MM-dd-yyyy',
    periodFrom: "",
    periodTo: "",
    periodSelect: true,
    periodData: undefined,
    periodSwitcher: false,
    defaultDateValue: undefined,
    companySwitcherActive: undefined,
    periodDataFetched: false,
    lastFetchedIntegration: null
  },
  reducers: {
    setCompanySwitcherActive: (state, action) => {
      state.companySwitcherActive = action.payload
    },
    setDateFormat: (state, action) => {
      state.value = action.payload
    },
    setPeriodFrom: (state, action) => {
      state.periodFrom = action.payload
    },
    setPeriodTo: (state, action) => {
      state.periodTo = action.payload
    },
    setPeriodSelect: (state, action) => {
      state.periodSelect = action.payload
    },
    setPeriodData: (state, action) => {
      state.periodData = action.payload
      state.periodDataFetched = true
    },
    setPeriodSwitcher: (state, action) => {
      state.periodSwitcher = action.payload
      if (action.payload === false) {
        state.periodDataFetched = false
      }
    },
    setDefaultDateValue: (state, action) => {
      state.defaultDateValue = action.payload
    },
    setPeriodDataFetched: (state, action) => {
      state.periodDataFetched = action.payload
    },
    setLastFetchedIntegration: (state, action) => {
      state.lastFetchedIntegration = action.payload
    }
  },

})

// Action creators are generated for each case reducer function
export const { setDateFormat, setPeriodFrom, setPeriodTo,
  setPeriodSelect, setPeriodData, setPeriodSwitcher,
  setDefaultDateValue, setCompanySwitcherActive,
  setPeriodDataFetched, setLastFetchedIntegration } = dateFormatSlice.actions

export default dateFormatSlice.reducer